import React from 'react'
import Header from "../header/Header";
import Footer from "../footer/Footer";
import ApartmentView from "./ApartmentView";
import {connect} from 'react-redux';
import {getApartmentById} from "../../redux/apartment-reducer";
import {withRouter} from "react-router-dom";
import SliderViewApartmentPage from "./slider-page/SliderViewApartmentPage";

class ApartmentViewContainer extends React.Component {
    componentDidMount() {
        let id = this.props.match.params.apartment_uuid;
        this.props.getApartmentById(id);
    }

    render() {
        return (
            <>
                <Header/>
                <SliderViewApartmentPage/>
                <div className="container">
                    <div className="row">
                        <ApartmentView {...this.props} apartment={this.props.apartment}/>
                    </div>
                </div>
                <Footer/>
            </>
        )
    }
};
let mapStateToProps = (state) => ({
    apartment: state.apartmentsPage.apartment
});

let WithUrlDataContainerComponent = withRouter(ApartmentViewContainer)
export default connect(mapStateToProps, {
    getApartmentById
})(WithUrlDataContainerComponent);